<template>
    <div :class="['single-collection-item', { 'no-access': userHasNoAccess }, { 'completed': isCourseCompleted(course.id) }]">
        <router-link
            :to="getRouteToCourse(course)"
            v-if="course.itemType === 'course'"
            class="single-collection-item__router-link"
        >
            <TotemAddToWatchlistButton
                v-if="showAddToFavourite && this.isDesktopView"
                :elementId="course.id"
                type="course"
            />
            <SingleCollectionPath
                v-if="isDesktopView"
                :progress="course.progress"
                :index="index"
                :length="amountOfCourses"
                :courseId="course.id"
                :isCourseCompleted="isCourseCompleted(course.id)"
                :isCourseHalfWatched="isCourseHalfWatched(course.id)"
                :isLoggedIn="isLoggedIn"
            />
            <SingleCollectionImage :course="course" />
            <div class="single-collection-item__info-box">
                <SingleCollectionInfo :course="course" />
                <TotemCourseInfo
                    :categories="course.categoriesWithAncestors"
                    :level="course.level"
                    :certs="course.certifiedBy"
                    :durations="course.durations"
                    :authorizationId="course.authorizationId"
                    :certifiedBy="course.certifiedBy"
                    :isTestAvailable="course.isTestAvailable"
                    :course="course"
                    class="single-collection-item__course-info"
                    v-if="isDesktopView"
                />
                <TotemLockIcon v-if="userHasNoAccess" isVertical />
            </div>
        </router-link>
        <template v-if="isMobileView">
            <ThumbnailActions @show-course-info="showCourseInfoDiv" :entity="course" itemType="course" />
            <div class="slide-container">
                <div class="slide-div" :class="{ 'active': showCourseInfo, 'inactive': !showSlider }" @animationend="onAnimationEnd">
                    <ThumbnailDetails itemType="course" :entity="course" />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import SingleCollectionPath from './SingleCollectionPath'
    import SingleCollectionImage from './SingleCollectionImage'
    import SingleCollectionInfo from './SingleCollectionInfo'
    import CourseImagesHelper from 'components/shared/global-courses-items/helper/course-images-helper'
    import CourseItemHelper from 'components/shared/global-courses-items/helper/course-item-helper'
    import ThumbnailActions from 'components/shared/global-courses-items/thumbnails/ThumbnailActions.vue'
    import ThumbnailDetails from 'components/shared/global-courses-items/thumbnails/ThumbnailDetails'
    import ThumbnailMoreInfoHelper from 'components/shared/global-courses-items/helper/thumbnail-more-info-helper'
    import routeHelper from 'components/shared/mixins/routeHelper'

    export default {
        components: {
            SingleCollectionPath,
            SingleCollectionImage,
            SingleCollectionInfo,
            ThumbnailActions,
            ThumbnailDetails
        },
        mixins: [ CourseImagesHelper, CourseItemHelper, ThumbnailMoreInfoHelper, routeHelper ],
        data () {
            return {
                descLength: 150
            }
        },
        props: {
            course: Object,
            index: Number,
            amountOfCourses: Number
        },
        computed: {
            ...mapGetters({
                isCourseCompleted: 'CompletedCourses/isCourseCompleted',
                isLoggedIn: 'isLoggedIn',
                isCourseHalfWatched: 'VideoLog/isCourseHalfWatched',
                isLive: 'Courses/isLive',
                getLiveEventDate: 'Courses/getLiveEventDate',
                getLiveEventTime: 'Courses/getLiveEventTime',
                mapCourseToRibbon: 'Courses/mapCourseToRibbon',
                mapCourseToTimeBasedRibbon: 'Courses/mapCourseToTimeBasedRibbon',
                showComingSoon: 'Courses/shouldShowComingSoon'
            })
        }
    }
</script>

<style lang="scss" scoped>
    @include totem_thumbnail_more_info;

    .single-collection-item {
        position: relative;
        display: flex;
        background: $white;
        border: 1px solid $quill_gray;
        transition: border 300ms ease-out;
        margin: 0 0 20px 0;
        min-height: 87px;
        border-radius: 4px;

        [class*="mobile"] & {
            position: relative;
            background: $white;
            display: flex;
            border-radius: 4px;
            flex-direction: column;
            height: 100%;
        }
        [class*="desktop"] & {
            height: 230px;
            margin: 0 0 50px 125px;
        }

        &.no-access {
            border-color: $gallery;
            background: $alabaster;
            color: $emperor;
        }

        &__router-link {
            display: flex;
            flex-direction: row;
            flex: 0 1 100%;

            [class*="mobile"] & {
                display: flex;
                flex-direction: column;
            }
        }

        &__info-box {
            position: relative;
            padding: 16px 30px 20px 30px;
            display: flex;
            flex-direction: column;
            width: 100%;

            [class*="mobile"] & {
                padding: 10px;
            }
        }

        &__course-info {
            margin-top: auto;
        }

        &:hover {
            cursor: pointer;
        }
    }
</style>
